import React, { useState, useEffect } from "react";
import classes from "./Managerole.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2 } from "lucide-react";
import "react-loading-skeleton/dist/skeleton.css";
import api, { withCompanyId } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import Select from "react-select";

const Managerole = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNewModalOpen, setIsNewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [loans, setLoans] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState(null); // For edit/delete
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  const [formData, setFormData] = useState({
    name: "",
  });

  const [editFormData, setEditFormData] = useState({
    name: "",
  });

  const handleChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      // For Select
      setFormData((prev) => ({ ...prev, [eOrName]: value }));
    } else {
      // For Input
      const { name, value } = eOrName.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleEditChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      // For Select
      setEditFormData((prev) => ({ ...prev, [eOrName]: value }));
    } else {
      // For Input
      const { name, value } = eOrName.target;
      setEditFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const payload = {
        name: formData.name,
      };

      const body = withCompanyId(payload);
      const response = await api.post(`/v1/payroll/role/store`, body);

      setFormData({
        name: "",
      });

      setIsModalOpen(false);
      fetchLoans(); // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Role Added",
        text: response.data.message || "Role added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message).flat().join("\n")
          : error.response?.data?.message || "Something went wrong.";

      Swal.fire({
        icon: "error",
        title: "Failed to Add Role",
        text: errorMessage,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const payload = {
        description: editFormData.description,
        receivable_account: editFormData.receivable_account,
      };

      const body = withCompanyId(payload);
      // ID as query param
      const response = await api.post(`/v1/loantype/update`, body, { params: { id: selectedLoan.id } });

      setIsNewModalOpen(false);
      setSelectedLoan(null);
      fetchLoans(); // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Loan Type Updated",
        text: response.data.message || "Loan type updated successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message).flat().join("\n")
          : error.response?.data?.message || "Failed to update location.";

      Swal.fire({
        icon: "error",
        title: "Failed to Update Location",
        text: errorMessage,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async () => {
    setDeleting(true);

    try {
      const response = await api.get(`/v1/loantype/delete`, { params: { id: selectedLoan.id } });

      setIsDeleteModalOpen(false);
      setSelectedLoan(null);
      fetchLoans(); // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Loan Type Deleted",
        text: response.data.message || "Loan type deleted successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete location.";

      Swal.fire({
        icon: "error",
        title: "Failed to Delete Location",
        text: errorMessage,
      });
    } finally {
      setDeleting(false);
    }
  };


  const openEditModal = (loan) => {
    setSelectedLoan(loan);
    setEditFormData({
      name: loan.name || loan.description,
    });
    setIsNewModalOpen(true);
  };

  const openDeleteModal = (loan) => {
    setSelectedLoan(loan);
    setIsDeleteModalOpen(true);
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      setError("Authorization token not found.");
      navigate("/signin");
      return;
    }

    fetchAccounts();
    fetchLoans();
  }, [navigate]);

  const fetchAccounts = async () => {
    try {
      const response = await api.get(`/v1/get-receivables-accounts`);

      if (response.data.status) {
        setAccountOptions(
          response.data.data.map((acc) => ({ value: acc.id, label: acc.gl_name }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch receivables accounts:", error);
      if (error.response?.status === 401) {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    }
  };

  const fetchLoans = async () => {
    try {
      const res = await api.get(`/v1/payroll/role`);

      setLoans(res.data?.data || []);
    } catch (err) {
      console.error("Error fetching roles:", err?.response?.data || err.message);
      setError("Failed to fetch roles. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getAccountName = (accountData) => {
    // Handle if accountData is an object (from API response)
    const accountId = typeof accountData === 'object' ? accountData?.id : accountData;
    
    const account = accountOptions.find(option => option.value === accountId);
    return account ? account.label : accountId;
  };

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.PgeContainerDisp}>
        <div className={classes.actionsbtn_On}>
          <button
            className={classes.btns_New}
            onClick={() => navigate("/transactions/sales-invoice/sale")}
          >
            Sales Invoice
          </button>
          <button
            className={classes.btns_New}
            onClick={() => navigate("/inventory/purchaseOrder")}
          >
            Purchase Invoice
          </button>
          <button
            className={`${classes.btns_New} ${classes.greens}`}
            onClick={() => navigate("/settings/product-services")}
          >
            Product & Services
          </button>
          <button className={`${classes.btns_News} ${classes.greens}`}>
            Manage Role
          </button>
        </div>

        <header className={classes.FrtHeaderOne}>
          <h2 className={classes.FrtTitleOne}>Manage Role</h2>
        </header>


{/* Cards commented out for now, can be re-enabled if needed in the future. */}
        {/* <div className={classes.entrjjyer}>
          <div className={classes.allkadsPage}>
            <div className={classes.thrdkadPage}>
              <div className={classes.kadOne}>
                <p className={classes.kdptgpt}>Total Loans</p>
                <p className={classes.kdptgpt1}>₦0.00</p>
                <div className={classes.rvnueOpt}>
                  <p className={classes.skaltxt001}>This month</p>
                </div>
              </div>
            </div>
            <div className={classes.frtkadIs}>
              <div className={classes.kadOne}>
                <p className={classes.kdptgpt}>Outstanding</p>
                <p className={classes.kdptgpt2}>₦0.00</p>
                <div className={classes.rvnueOpt}>
                  <p className={classes.skaltxt001}>Pending payments</p>
                </div>
              </div>
            </div>
            <div className={classes.fiftkadOn}>
              <div className={classes.kadOne}>
                <p className={classes.kdptgpt}>Overdue</p>
                <p className={classes.kdptgpt3}>₦0.00</p>
                <div className={classes.rvnueOpt}>
                  <p className={classes.skaltxt001}>Past due dates</p>
                </div>
              </div>
            </div>
            <div className={classes.frstkadOne}>
              <div className={classes.kadOne}>
                <p className={classes.kdptgpt}>This month</p>
                <p className={classes.kdptgpt4}>0</p>
                <div className={classes.rvnueOpt}>
                  <p className={classes.skaltxt001}>Total invoices</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className={classes.headerforActions}>
          <div className={classes.actionsSideRight}>
            <div className={classes.inputWrapperTxt}>
              <img
                src={searchicon}
                alt="Search"
                className={classes.inputIconGreenLrg}
              />
              <input
                type="text"
                className={classes.searchLxtBar}
                placeholder="Search Loan"
              />
            </div>
          </div>
          <button
            className={classes.btnssBtnss}
            onClick={() => setIsModalOpen(true)}
          >
            Add Role
          </button>
        </div>

        <div className={classes.newUserCont}>
          <table className={classes.newUserTable}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Role Name</th>
                <th>Created At</th>
                <th className={classes.actionMove}>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array(5).fill().map((_, idx) => (
                  <tr key={idx}>
                    {Array(4).fill().map((_, i) => (
                      <td key={i}><Skeleton height={20} /></td>
                    ))}
                  </tr>
                ))
              ) : loans.length === 0 ? (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center" }}>No Roles found.</td>
                </tr>
              ) : (
                loans.map((loan, index) => (
                  <tr key={loan.id}>
                    <td>{index + 1}</td>
                    <td>{loan.name || loan.description}</td>
                    <td>{new Date(loan.created_at).toLocaleDateString()}</td>
                    <td className={classes.actionsEditDelete}>
                      <Pen
                        size={16}
                        className={classes.editActionIcon}
                        onClick={() => openEditModal(loan)}
                        style={{ cursor: 'pointer' }}
                      />
                      <Trash2
                        size={16}
                        className={classes.deleteActionIcon}
                        onClick={() => openDeleteModal(loan)}
                        style={{ cursor: 'pointer' }}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className={classes.paginationContainertxt}>
            <div className={classes.paginationControlstxt}>
              <button>First</button>
              <button className={classes.activation}>1</button>
              <button>Last</button>
              <span className={classes.pageDisplayText}>
                Displaying 1 - {loans.length} of {loans.length}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Add Location Modal */}
      {isModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalContent}>
            <div className={classes.modalModalHeader}>
              <h2>Add Role</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => setIsModalOpen(false)}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className={classes.modalModalBody}>
                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Role Name</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter Role Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className={classes.modalFormFooter}>
                  <button
                    className={classes.processModalBtn0}
                    disabled={submitting}
                    type="submit"
                  >
                    {submitting ? "Adding..." : "Add Role"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Role Modal */}
      {isNewModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalContent}>
            <div className={classes.modalModalHeader}>
              <h2>Edit Role</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => {
                  setIsNewModalOpen(false);
                  setSelectedLoan(null);
                }}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleEditSubmit}>
              <div className={classes.modalModalBody}>
                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Role Name</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter Role Name"
                      value={editFormData.name}
                      onChange={handleEditChange}
                      required
                    />
                  </div>
                </div>

                <div className={classes.modalFormFooter}>
                  <button
                    className={classes.processModalBtn0}
                    disabled={submitting}
                    type="submit"
                  >
                    {submitting ? "Updating..." : "Update Role"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Location Modal */}
      {isDeleteModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalDeleteContent}>
            <div className={classes.modalModalHeader}>
              <h2 style={{ marginBottom: "auto" }}>Delete Role</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => {
                  setIsDeleteModalOpen(false);
                  setSelectedLoan(null);
                }}
              >
                &times;
              </button>
            </div>

            <div className={classes.modalModalBodyText00}>
              <p>
                Are you sure you want to delete the role \"{selectedLoan?.description}\"?
                <br />This action cannot be undone.
              </p>
              <div className={classes.modalFormDelFooter}>
                <button
                  className={classes.ModalDeleteBtn0}
                  onClick={handleDelete}
                  disabled={deleting}
                >
                  {deleting ? "Deleting..." : "Delete Role"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Managerole;
